// redux/formalityRequestSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  request: null, // { fmId, fmUserId, fmCustId, fmTemplateSlug, fmTemplateVersion, fmStatus, fmStepIndex, fmData, ... }
};


const makeBlankRequest = (patch = {}) => ({
  frId: null,
  frUserId: null,
  frCustId: null,
  frTemplateId: null,
  frStatus: 'draft',
  frStepIndex: 1,
  ...patch,
});


const formalityRequestSlice = createSlice({
  name: 'formalityRequest',
  initialState,
  reducers: {
    // Remplace entièrement la request courante 
    setFormalityRequest: (state, action) => {
      const payload = action.payload;
      if (payload) {
        state.request = { ...makeBlankRequest(), ...payload };
      } else {
        state.request = makeBlankRequest(); // 👈 blank par défaut
      }
    },
    // Merge superficiel sur l’objet request (sans créer d’API call)
    updateFormalityRequest: (state, action) => {


      const patch = action.payload || {};

      console.log('ICI', patch)

      state.request = { ...(state.request || {}), ...patch };
    },

    // Met à jour une partie de fmData (merge)
    setFmDataPartial: (state, action) => {
      const patch = action.payload || {};
      if (!state.request) state.request = {};
      state.request.fmData = { ...(state.request.fmData || {}), ...patch };
    },

    // Change l’index d’étape
    setFmStepIndex: (state, action) => {
      if (!state.request) state.request = {};
      state.request.fmStepIndex = action.payload ?? 0;
    },

    // Reset complet
    resetFormalityRequest: () => initialState,
  },
});

export const {
  setFormalityRequest,
  updateFormalityRequest,
  setFmDataPartial,
  setFmStepIndex,
  resetFormalityRequest,
} = formalityRequestSlice.actions;


export default formalityRequestSlice.reducer; // 👈 manquait